import React, { useMemo } from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import useTranslation from '../../../../../Hooks/useTranslation';
import Loading from '../../../../../Components/Loading';
import { useDocumentationFoldersQuery } from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import useSelectValueGuard from '../../../Hooks/useSelectValueGuard';

interface Props {
	onChange?: (value: SelectValue) => void;
	patientId: string;
	value?: SelectValue;
	error?: FieldError;
}

const ECardFolderSelect: React.FC<Props> = ({
	onChange,
	patientId,
	value,
	error,
}) => {
	const { t } = useTranslation();
	const { data, isLoading } = useDocumentationFoldersQuery({
		userId: patientId,
	});

	const options: SelectValue[] = useMemo(() => {
		const temp: SelectValue[] = [];
		data?.documentationFolders?.data?.forEach(item => {
			temp.push({
				label: item?.name ?? '',
				value: item?.id,
			});
		});
		return temp;
	}, [data]);

	useSelectValueGuard({ options, value, onChange });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={value}
			error={error}
			portal
		/>
	);
};
export default ECardFolderSelect;
